export enum RuntimeEnvironments {
    DEV = 'DEV',
    SAT = 'SAT',
    PROD = 'PROD',
  }
  export enum MSAEnvironments {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
  }
